import { render, staticRenderFns } from "./clientModal.vue?vue&type=template&id=c3ca353e&scoped=true&"
import script from "./clientModal.vue?vue&type=script&lang=js&"
export * from "./clientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ca353e",
  null
  
)

export default component.exports